import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=2435eaaf&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports